import { getAppKey, addAppKey, getAppToken } from '../../../../api/monitor';

export default {
  data() {
    return {
      loading: true
    }
  },
  methods: {
    //  获取appkey
    getKey() {
      return new Promise(resolve => {
        getAppKey().then(res => {
          resolve(res.body.data[0])
        })
      })
    },
    //  获取appToken
    getToken(params) {
      return new Promise(resolve => {
        getAppToken(params).then(res => {
          resolve(res.body.data)
        })
      })
    },
    //  更新token
    editToken(params) {
      return new Promise(resolve => {
        addAppKey(params).then(res => {
          resolve(res)
        })
      })
    },
  },
}
